<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <form @submit.prevent="submitForm()">
        <div class="container">
          <div class="board_wrap">
            <div class="board_title">
              <div class="inputHeader board" v-if="form.title.hasError">
                <span class="warn" v-text="form.title.errorTxt"></span>
              </div>
              <label>
                <input type="text" placeholder="제목을 입력해주세요." v-model="form.title.value" @keyup="blurTitle()">
              </label>
            </div>
            <div class="board_body">
              <p class="write_date">
                날짜: {{this.form.date.value}}
              </p>
              <div class="inputHeader" v-if="form.content.hasError">
                <span class="warn" v-text="form.content.errorTxt"></span>
              </div>
              <div class="write_space">
                <textarea placeholder="공지사항을 작성해 주세요." v-model="form.content.value" @keyup="blurContent()"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="btnWrap" :class="{visible : form.title.flag && form.content.flag}">
          <button type="submit" class="callTerms" :disabled="!checkAll()">확인</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '작성이 완료되었습니다.',
        nextLink: '/noticeList',
        confirmBtnText: '확인',
        count: 'another'
      },
      transDate: {
        headerName: '공지사항',
        prevUrl: '/noticeList'
      },
      form: {
        code: '',
        title: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        content: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        date: {
          value: ''
        },
        important: {
          value: false
        }
      }
    }
  },
  computed: {
    ...mapGetters([]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([]),
    checkAll () {
      return !!(this.form.title.flag && this.form.content.flag)
    },
    blurTitle () {
      this.form.title.flag = false
      this.checkTitle()
    },
    checkTitle () {
      if (this.form.title.flag) return true

      const title = this.form.title.value
      if (title === '') {
        this.form.title.hasError = true
        this.form.title.errorTxt = '제목을 입력해주세요.'
        return false
      }
      this.form.title.flag = true
      this.form.title.hasError = false
      this.form.title.errorTxt = ''
      return true
    },
    blurContent () {
      this.form.content.flag = false
      this.checkContent()
    },
    checkContent () {
      if (this.form.content.flag) return true

      const content = this.form.content.value
      if (content === '') {
        this.form.content.hasError = true
        this.form.content.errorTxt = '내용을 입력해주세요.'
        return false
      }
      this.form.content.flag = true
      this.form.content.hasError = false
      this.form.content.errorTxt = ''
      return true
    },
    checkToday () {
      const today = new Date()
      const year = today.getFullYear()
      let month = today.getMonth() + 1
      let date = today.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      this.form.date.value = year + '-' + month + '-' + date
    },
    submitForm () {
      if (this.checkAll()) {
        this.formAction()
      } else {
        this.form.title.hasError = true
        this.form.title.errorTxt = '제목을 입력해주세요.'
        this.form.content.hasError = true
        this.form.content.errorTxt = '내용을 입력해주세요.'
      }
    },
    async formAction () {
      await this.SET_POPUP(true)
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    this.checkToday()
  }
}
</script>

<style lang="scss" scoped>
</style>
